import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Requires user to be logged in and approved
export const ProtectedRoute = ({ children }) => {
  const { user, loading, sessionExpired, isPending } = useAuth();
  
  if (loading) {
    return <div className="loading-screen">Loading...</div>;
  }
  
  if (!user || sessionExpired || isPending) {
    return <Navigate to="/login" />;
  }
  
  return children;
};

// Requires user to be an Armorer or Admin
export const ArmorerRoute = ({ children }) => {
  const { user, isArmorer, loading } = useAuth();
  
  if (loading) {
    return <div className="loading-screen">Loading...</div>;
  }
  
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  if (!isArmorer) {
    return <Navigate to="/no-clearance" />;
  }
  
  return children;
};

// Requires user to be an Admin
export const AdminRoute = ({ children }) => {
  const { user, isAdmin, loading } = useAuth();
  
  if (loading) {
    return <div className="loading-screen">Loading...</div>;
  }
  
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  if (!isAdmin) {
    return <Navigate to="/no-clearance" />;
  }
  
  return children;
};
